import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { 
  colorAccent,
  colorAccentHover,
  colorAdditional,
  colorBubbleActive,
  colorText,
  colorBubble,
} from '@/utils/palette';
import { 
  paddingRight,
  paddingLeft,
  marginRight,
  marginLeft, 
  right, 
  left,
} from '@/utils/directions';

const ChatBubble = ({ avatar, message }) => { // Add curly braces for the component function
  const currentTime = new Date();
  const formattedTime = currentTime.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  });
  
  return ( // Add a return statement to return the JSX
    <ChatBubbleWrap>
      {message.role === 'admin' && (
        <ChatBubbleAvatar>
          <img src={avatar} alt="ava" />
        </ChatBubbleAvatar>
      )}
      {message.file ? (
        <ChatBubbleMessageWrap file>
          <ChatBubbleContactName>User Name</ChatBubbleContactName>
          <img src={message.file.preview} alt={message.message} />
          <ChatBubbleDate>{moment(message.date).format('lll')}</ChatBubbleDate>
          <ChatBubbleDownloadWrap>
            <ChatBubbleFileName>
              <span>{message.message}</span>
              <span>{message.file.size}</span>
            </ChatBubbleFileName>
            <ChatBubbleDownload href={message.file.preview} download>Download</ChatBubbleDownload>
          </ChatBubbleDownloadWrap>
        </ChatBubbleMessageWrap>
      ) : (
        <ChatBubbleMessageWrap
          style={
            message.role === 'user'
            ? {
                background: '#6d7c81',
                marginLeft: 'auto',
                borderRadius: '15px 0 15px 15px',
                padding: '15px 15px 10px 12px',
                paddingTop: '7px',
                paddingBottom: '4px',
              }
            : {}
          }
        >
          {message.role === 'user' && (
            <ChatBubbleContactName style={{ textTransform: 'capitalize' }}>
              {JSON.parse(localStorage.getItem('user')).data.user.firstName}{' '}
              {JSON.parse(localStorage.getItem('user')).data.user.lastName}
            </ChatBubbleContactName>
          )}
          {message.role === 'admin' && (
            <ChatBubbleContactName>Administrator</ChatBubbleContactName>
          )}
          <ChatBubbleMessage>{message.msg}</ChatBubbleMessage>
          <ChatBubbleDate>{formattedTime}</ChatBubbleDate> {/* Use formattedTime here */}
        </ChatBubbleMessageWrap>
      )}
      {message.role === 'user' && (
        <ChatBubbleAvatar 
          style={{
           marginLeft: '5px',
          }}
        >
          <img src={`${process.env.PUBLIC_URL}/img/avaat.png`} alt="ava" />
        </ChatBubbleAvatar>
      )}
    </ChatBubbleWrap>
  );
};

ChatBubble.defaultProps = {
  active: false,
};

export default ChatBubble;

// region STYLES

const ChatBubbleWrap = styled.div`
  display: flex;
  margin-bottom: 10px;
  position: relative;

  ${props => props.active && `
  
    .chat__bubble-message-wrap {
      background-color: ${colorBubbleActive(props)};
    }
  `}

  &:last-child {
    margin-bottom: 0;
  }
`;

const ChatBubbleAvatar = styled.div`
  width: 30px;
  height: 30px;
  min-width: 30px;
  overflow: hidden;
  border-radius: 50%;
  display: none;
  ${marginRight}: 5px;

  img {
    height: 100%;
    width: 100%;
  }

  @media screen and (min-width: 425px) {
    display: block;
  }
`;

const ChatBubbleMessageWrap = styled.div`
  max-width: 260px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-radius: 0 20px 20px 20px;
  position: relative;
  ${paddingRight}: 12px;
  ${paddingLeft}: 12px;
  background-color: #1e2e33;
  ${props => props.file && 'padding: 10px 20px 20px 20px'};

  @media screen and (min-width: 1366px) {
    position: static;
  }

  img {
    max-width: 215px;
  }
`;

const ChatBubbleContactName = styled.p`
  margin-top: 0;
  margin-bottom: 2px;
  font-size: 13px;
  font-weight: 500;
  color: ${colorAccent};
  ${paddingRight}: 50px;
`;

const ChatBubbleDate = styled.p`
  color: ${colorText};
  font-size: 10px;
  margin: 0;
  text-align: end;
  ${right}: 36px;

  @media screen and (min-width: 1366px) {
    ${right}: 0;
  }
`;

const ChatBubbleMessage = styled.p`
  margin: 0 0 2px 0;
  font-size: 12px;
  color: ${colorText};
`;

const ChatBubbleDownload = styled.a`
  color: ${colorAccent};
  font-weight: 500;

  &:hover {
    color: ${colorAccentHover};
  }
`;

const ChatBubbleDownloadWrap = styled.div`
  max-width: 215px;
  margin-top: 10px;
  font-size: 10px;

  @media screen and (min-width: 1366px) {
    position: absolute;
    top: 0;
    max-width: calc(100% - 375px);
    width: 300px;
    margin-top: 0;
    ${left}: 315px;
  }
`;

const ChatBubbleFileName = styled.p`
  white-space: nowrap;
  display: flex;

  span:first-child {
    display: block;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  span:last-child {
    color: ${colorAdditional};
    ${marginLeft}: 5px;
  }
`;

// endregion
